export default "__VITE_ASSET__D9vB9v5E__"